<template>
  <div class="news">
    <!-- <section class="page__min-width page__max-width margin-center index-news">
      <header class="index-news__header"> -->
<!--        <div data-v-1564b99a="" style="text-align: center; margin-bottom: 29px;padding-top: 69px;">-->
<!--          <span-->
<!--            data-v-1564b99a=""-->
<!--            class="Header_line"-->
<!--            style="margin-right: 20px"-->
<!--          ></span>-->
<!--          <span-->
<!--            data-v-1564b99a=""-->
<!--            style="-->
<!--              font-size: 40px;-->
<!--              font-family: 'Source Han Sans CN';-->
<!--              font-weight: bold;-->
<!--              color:#331318;-->
<!--            "-->
<!--            >新闻中心</span-->
<!--          >-->
<!--          <span-->
<!--            data-v-1564b99a=""-->
<!--            class="Header_line"-->
<!--            style="margin-left: 20px"-->
<!--          ></span>-->
<!--        </div>-->
        <!-- <img class="title-image" :src="ossPath + '/pages/home/news_title.png'" alt="">
      </header>
      <div class="index-news__main">
        <template v-if="newsList">
          <section class="news-box" v-for="(item, index) of newsList" :key="item.id">
          <div class="news-box-main">
            <router-link :title="item.contentTitle"
                         :to="`/newsDetails?id=${item.id}&newsTypeName=${item.categoryTitle || ''}${item.contentImgOss ? `&poster=${encodeURIComponent(item.contentImgOss)}` : ''}`"
                         @click.native="sendCustomerOperationRecord('新闻中心', item.contentTitle)"
                         class="news-box-cover">
              <div class="news-box-image">
                <router-link :title="item.contentTitle" :to="`/news?newType=${item.categoryId || ''}`"
                             class="news-box-tag"><span style="margin-left:5px">{{ item.categoryTitle }}</span>
                </router-link>
                <img :src="item.contentImgOss||'/static/images/news/news_list_cover.jpg'" :alt="item.contentTitle">
              </div>
              <h5 class="news-box-title">{{ item.contentTitle || '' }}</h5>
              <span class="news-box-time">{{ item.contentDatetime || '' }}</span>
            </router-link>
          </div> -->
            <!-- <div class="news-box-main">
              <router-link
                :to="`/newsDetails?id=${item.id}&newsTypeName=${
                  item.categoryTitle || ''
                }`"
                :title="item.contentTitle"
                class="news-box__cover"
              >
                <img
                  :src="
                    item.contentImgOss ||
                    '/static/images/news/news_list_cover.jpg'
                  "
                  :alt="item.contentTitle"
                />
              </router-link>
              <div class="news-box__container">
                <router-link
                  class="news-box__tag"
                  :to="`/news?newType=${item.categoryId || ''}`"
                  :title="item.categoryTitle"
                  :class="[index % 2 === 0 ? 'tag-warning' : 'tag-danger']"
                  >{{ item.categoryTitle || "&nbsp;" }}</router-link
                >
                <h5 class="news-box__title" @click="openNewsDetails(item)">
                  {{ item.contentTitle || "&nbsp;" }}
                </h5>
                <time class="news-box__time" :datetime="item.contentDatetime">{{
                  item.contentDatetime || "&nbsp;"
                }}</time>
                <p class="news-box__content">
                  {{ item.contentDescription || "&nbsp;" }}
                </p>
              </div>
            </div>

            <div class="news-box-big">
              <router-link
                :to="`/newsDetails?id=${item.id}&newsTypeName=${
                  item.categoryTitle || ''
                }`"
                :title="item.contentTitle"
                class="news-box__cover"
              >
                <img
                  :src="
                    item.contentImgOss ||
                    '/static/images/news/news_list_cover.jpg'
                  "
                  :alt="item.contentTitle"
                />
              </router-link>
              <div class="news-box__container">
                <router-link
                  class="news-box__tag"
                  :to="`/news?newType=${item.categoryId || ''}`"
                  :title="item.categoryTitle"
                  :class="[index % 2 === 0 ? 'tag-warning' : 'tag-danger']"
                  >{{ item.categoryTitle || "&nbsp;" }}</router-link
                >
                <h5 class="news-box__title" @click="openNewsDetails(item)">
                  {{ item.contentTitle || "&nbsp;" }}
                </h5>
                <time class="news-box__time" :datetime="item.contentDatetime">{{
                  item.contentDatetime || "&nbsp;"
                }}</time>
                <p class="news-box__content">
                  {{ item.contentDescription || "&nbsp;" }}
                </p>
                <span @click="openNewsDetails(item)" class="news-box__move"
                  >查看更多<i class="el-icon-arrow-right"></i
                ></span>
              </div>
            </div> -->
          <!-- </section>
        </template>
      </div>
      <footer class="index-news__footer">
        <router-link
          :to="{ name: 'news' }"
          title="新闻中心"
          class="el-button index-news__footer-move el-button--primary"
          @click.native="sendCustomerOperationRecord('查看更多新闻')"
          >查看更多新闻<i class="el-icon-d-arrow-right"></i
        ></router-link>
      </footer>
    </section> -->

    <div class="news-module-box">
      <div class="news-module-box__title">
        <img :src="`${ossPath}/pages/home/news-module-title.png`" alt="">
      </div>
      <section class="news-info">
        <div class="near-news-card" @click="checkNewsDetails(nearNews)" @mouseover="hoverIndex = 'near'" @mouseleave="hoverIndex = null" v-if="nearNews.id">
          <div>
            <img :src="nearNews.contentImgOss" alt="">
          </div>
          <h3 class="news-title" :title="nearNews.contentTitle">{{nearNews.contentTitle || ''}}</h3>
          <p class="news-time">{{nearNews.contentDatetime || ''}}</p>
          <img class="active" v-if="hoverIndex === 'near'" :src="`${ossPath}/pages/home/icon_news_orange_arrow.png`" alt="">
        </div>
        <ul>
          <li class="news-card" @click="checkNewsDetails(item)" @mouseover="hoverIndex = i" @mouseleave="hoverIndex = null" v-for="(item, i) of newsList" :key="item.id">
            <div class="news-card_content">
              <img :src="item.contentImgOss||'/static/images/news/news_list_cover.jpg'" :alt="item.contentTitle">
              <div>
                <h3 class="news-title" :title="item.contentTitle">{{ item.contentTitle || '' }}</h3>
                <p class="news-time">{{ item.contentDatetime || '' }}</p>
              </div>
              <img class="active" v-show="hoverIndex === i" :src="`${ossPath}/pages/home/icon_news_orange_arrow.png`" alt="">
            </div>
          </li>
        </ul>
      </section>
      <div class="new-more-bar" @click="enterNewsCenter">
        <span style="vertical-align: 2px">查看更多新闻资讯</span>
        <img :src="`${ossPath}/pages/home/icon_news_gray_arrow.png`" alt="">
      </div>
    </div>    
  </div>
</template>

<script>
import qs from "qs";
import { isObject, sendCustomerOperationRecord } from "@/assets/js/utils";

export default {
  name: "newsModule",
  data() {
    const ossPath = this.ossPath;
    return {
      ossPath,
      loading: false,
      newsList: [],
      sendCustomerOperationRecord,
      nearNews: {},
      hoverIndex: null
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    /**
     * 获取 分类列表
     */
    getNewsList() {
      let data = {
        appCode: "huodainews", /* 新闻模块的 */
      };
      this.loading = true;
      return this.axios
        .post("/cms/findHuodaipinNewsCenter", qs.stringify(data))
        .then((res) => {
          console.log("999", res);
          this.loading = false;
          if (res.data.code !== 1) {
            return Promise.reject(new Error(res.data.message || "服务器繁忙"));
          }
          let list = res.data.data || [];
          this.newsList = list.splice(1,3);
          this.nearNews = list[0]
          return list;
        })
        .catch((res) => {
          console.error(res);
          // this.$message.error(res.message||'服务器繁忙，请稍后再试！');
          this.loading = false;
          this.newsList = [];
        });
    },
    enterNewsCenter() {
      this.sendCustomerOperationRecord('查看更多新闻')
      this.$router.push({
        name: 'news'
      })
    },
    checkNewsDetails(item) {
      if(!(isObject(item) && item.id)) return false;
      sendCustomerOperationRecord('新闻中心', item.contentTitle)
      const poterStr = item.contentImgOss ? `&poster=${encodeURIComponent(item.contentImgOss)}` : ''
      this.$router.push(`/newsDetails?id=${item.id}&newsTypeName=${this.newsTypeName||''}${poterStr}`)
    },
    openNewsDetails(item) {
      if (!(isObject(item) && item.id)) return false;
      this.$router.push(
        `/newsDetails?id=${item.id}&newsTypeName=${item.categoryTitle || ""}`
      );
    }
  },
};
</script>

<style scoped lang="scss">
.news{
  background: #EFF1F1;
}
.index-news {
  /*width: 80%;*/
  font-family: PingFang SC;
  /*a:hover{*/
  /*text-decoration: none;*/
  /*}*/
  &__header {
    //margin-bottom: 80px;
    overflow: hidden;
    &-image {
      display: block;
      width: auto;
      height: 54px;
      margin-left: auto;
      margin-right: auto;
    }
    .title-image{
      max-width: 100%;
      height: auto;
      display: block;
      border: none;
      margin: 80px auto ;
    }
  }
  &__main {
    display: flex;
    justify-content: space-between;
  }
  &__footer {
    text-align: center;
    &-move {
      min-width: 180px;
      font-size: 18px;
      height: 50px;
      line-height: 50px;
      padding-top: 0;
      padding-bottom: 0;
      margin-top: 70px;
      margin-bottom: 70px;
      i {
        margin-left: 10px;
      }
    }
  }
}

.news-box {
  flex: 1;
  max-width: 380px;
  margin-bottom: 70px;
  height: 370px;
  overflow: hidden;
  font-size: 14px;
  position: relative;
  z-index: 1;
  background-color: #FFF;
  border-radius: 30px;
  padding: 26px 30px;
  box-sizing: border-box;
  & + & {
    /*margin-left: 80px;*/
  }
  &__cover {
    display: block;
    height: 100%;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__container {
  }

  &__tag {
    display: inline-block;
    min-width: 72px;
    padding: 0 10px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    border-radius: 5px;
    margin-bottom: 15px;
  }
  &__title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;

    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-word;
    cursor: pointer;
  }
  &__time {
    display: block;
    font-weight: 500;
    margin-bottom: 15px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__content {
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-word;
  }
  &__move {
    display: block;
    text-align: right;
    color: inherit;
    font-weight: bold;
    cursor: pointer;
  }
}
.news-box-main {
  width: 100%;
  height: 100%;
  // display: flex;

  // .news-box__cover {
  //   width: 200px;
  //   min-width: 200px;
  // }

  // .news-box__container {
  //   margin-left: 20px;
  //   flex: 1;
  //   overflow: hidden;
  // }

  // .news-box__title {
  //   color: #333;
  // }

  // .news-box__time {
  //   color: #999999;
  // }

  // .news-box__content {
  //   color: #333333;
  // }

  .news-box-image {
    width: 100%;
    height: 200px;
    overflow: hidden;
    border-radius: 30px;
  }

  img{
    width: 100%;
    height: 100%;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.6s;
  }

  img:hover {
    transform: scale(1.3);
  }

  .news-box-tag {
    min-width: 66px;
    padding: 0 6px;
    height: 30px;
    position: absolute;
    z-index: 1;
    top:44px;
    left: 43px;
    background-color: #FFBF4D;
    // padding: 4px;
    border-radius: 15px 15px 15px 0;
    color: #fff;
    font-family: "Source Han Sans CN";
    font-size: 14px;
    font-weight: 400;
    text-decoration: none;
    line-height: 30px;
  }

  .news-box-title {
    margin: 29px 0 21px;
    font-size: 15px;
    font-family: "Source Han Sans CN";
    font-weight: bold;
    color: #333333;
  }

  .news-box-time {
    font-size: 14px;
    color: #999999;
    font-family: "Source Han Sans CN";
  }

  .news-box-content {
    margin-top: 13px;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    word-break: break-word;
    color: #666666;
    font-size: 14px;
    font-family: "Source Han Sans CN";
    line-height: 24px;
  }

  .news-box-cover {
    text-decoration: none;
    cursor: pointer;
  }

}
.news-box-big {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  color: white;

  // .news-box__cover {
  //   width: 100%;
  //   position: relative;
  //   z-index: 1;
  //   img {
  //     filter: brightness(50%);
  //   }
  // }
  // .news-box__container {
  //   padding: 20px;
  //   position: absolute;
  //   z-index: 2;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  // }
  // .news-box__title {
  //   color: white;
  // }
  // .news-box__time {
  //   display: none;
  // }
  // .news-box__content {
  //   display: none;
  // }
}

.news-box {
  &-big {
    transition: top ease 0.4s;
    top: 102%;
  }
  &:hover &-big {
    top: 0;
  }
}

// .tag-warning {
//   color: #f2b31b;
//   background-color: #fff2d3;
// }
// .tag-danger {
//   color: #FF4D01;
//   background-color: #ffe6e9;
// }

.index-news__footer-move {
  min-width: 180px;
  font-size: 18px;
  height: 50px;
  line-height: 50px;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0px;
  margin-bottom: 70px;
  width: 200px;
  height: 50px;
  background: #ffe3e6;
  border: 2px solid #FF4D01;
  border-radius: 25px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FF4D01;
  line-height: 46px;
  text-decoration:none;
}

.index-news__footer-move:hover {
  background:#FF4D01;
  color: #fff;
}

.page__max-width {
  max-width: 1200px !important;
}

.Header_line {
  display: inline-block;
  width: 133px;
  border-top: 2px solid #FF4D01;
  vertical-align: 10px;
}
.news-module-box {
  width: 1200px;
  margin: 0 auto;
  padding: 45px 0 85px;
  &__title {
    text-align: center;
  }
  .news-title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 700;
    color: #141414;
    line-height: 22px;
  }
  .news-time {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
  .news-info {
    margin-top: 36px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }
  .new-more-bar {
    width: 1200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    color: #141414;
    border-radius: 8px;
    cursor: pointer;
    transition: all .3s ease;
    &:hover {
      box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
    }
  }
  .near-news-card {
    position: relative;
    padding: 18px;
    width: 634px;
    height: 462px;
    background: #FFFFFF;
    border-radius: 11px;
    cursor: pointer;
    transition: all .3s ease;
    &:hover {
      box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
    }
    img:not(.active) {
      margin-bottom: 10px;
      width: 634px;
      height: 396px;
      border-radius: 7px;
    }
    .news-title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .active {
      right: 18px;
      bottom: 18px;
    }
  }
  .active {
    position: absolute;
    width: 22px;
    height: 22px;
    right: 0;
    bottom: 0;
    transform: all .3s;
  }
  .news-card{
    margin-bottom: 22px;
    padding: 12px;
    width: 486px;
    height: 127px;
    background: #FFFFFF;
    border-radius: 7px;
    cursor: pointer;
    transition: all .3s ease;
    &:hover {
      box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
    }
    &:last-of-type {
      margin-bottom: 0;
    }
    &_content {
      position: relative;
      display: flex;
      img:not(.active) {
        margin-right: 10px;
        width: 205px;
        height: 128px;
        border-radius: 2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/placeindexInfo/newsModule.vue